const batterymaps =[
    {
      "battery_id": 1,
      "description": "No Battery",
      "manufacturer": "a",
      "watts": 0,
      "unit_cost": 0,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 1,
      "Qty": 1
    },
    {
      "battery_id": 900,
      "description": "GIV Energy 5.2kW Battery",
      "manufacturer": "GIV ENERGY",
      "watts": 5200,
      "unit_cost": 1800,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 900,
      "Qty": 1
    },
    {
      "battery_id": 905,
      "description": "2 x GIV Energy 5.2kW Battery",
      "manufacturer": "GIV ENERGY",
      "watts": 10400,
      "unit_cost": 3600,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 900,
      "Qty": 2
    },
    {
      "battery_id": 910,
      "description": "3 x GIV Energy 5.2kW Battery",
      "manufacturer": "GIV ENERGY",
      "watts": 15600,
      "unit_cost": 5400,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 900,
      "Qty": 3
    },
    {
      "battery_id": 915,
      "description": "4 x GIV Energy 5.2kW Battery",
      "manufacturer": "GIV ENERGY",
      "watts": 20800,
      "unit_cost": 7200,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 900,
      "Qty": 4
    },
    {
      "battery_id": 920,
      "description": "5 x GIV Energy 5.2kW Battery",
      "manufacturer": "GIV ENERGY",
      "watts": 26000,
      "unit_cost": 9000,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 900,
      "Qty": 5
    },
    {
      "battery_id": 7,
      "description": "GIV Energy 8.24kW Battery",
      "manufacturer": "GIV ENERGY",
      "watts": 8243,
      "unit_cost": 2216,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 7,
      "Qty": 1
    },
    {
      "battery_id": 57,
      "description": "GIV Energy 2 x 8.24kW Batteries - 16.48kW",
      "manufacturer": "GIV ENERGY",
      "watts": 16486,
      "unit_cost": 4432,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 7,
      "Qty": 2
    },
    {
      "battery_id": 12,
      "description": "Growatt 1 x ATL 3.3kW lithium battery",
      "manufacturer": "GROWATT",
      "watts": 3300,
      "unit_cost": 835,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 12,
      "Qty": 1
    },
    {
      "battery_id": 17,
      "description": "Growatt 2 x ATL 3.3kW lithium battery",
      "manufacturer": "GROWATT",
      "watts": 6600,
      "unit_cost": 1670,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 12,
      "Qty": 2
    },
    {
      "battery_id": 19,
      "description": "Growatt 3 x ATL 3.3kW lithium battery",
      "manufacturer": "GROWATT",
      "watts": 9900,
      "unit_cost": 2495,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 12,
      "Qty": 3
    },
    {
      "battery_id": 8,
      "description": "Growatt 1 x 6.5kW Battery",
      "manufacturer": "GROWATT",
      "watts": 6500,
      "unit_cost": 1625,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 8,
      "Qty": 1
    },
    {
      "battery_id": 15,
      "description": "Growatt 2 x 6.5kW Batteries - 13kW",
      "manufacturer": "GROWATT",
      "watts": 13000,
      "unit_cost": 3250,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 8,
      "Qty": 2
    },
    {
      "battery_id": 14,
      "description": "Growatt 3 x 6.5kW Batteries - 19.5kW",
      "manufacturer": "GROWATT",
      "watts": 19500,
      "unit_cost": 4875,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 8,
      "Qty": 3
    },
    {
      "battery_id": 24,
      "description": "Growatt 4 x 6.5kW Batteries - 26kW",
      "manufacturer": "GROWATT",
      "watts": 26000,
      "unit_cost": 6500,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 8,
      "Qty": 4
    },
    {
      "battery_id": 2,
      "description": "Pylontech 2.4kW Battery",
      "manufacturer": "Pylontech",
      "watts": 2400,
      "unit_cost": 555,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 2,
      "Qty": 1
    },
    {
      "battery_id": 3,
      "description": "Pylontech - 2 x 2.4kW Batteries - 4.8kW",
      "manufacturer": "Pylontech",
      "watts": 4800,
      "unit_cost": 1110,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 2,
      "Qty": 2
    },
    {
      "battery_id": 60,
      "description": "Pylontech - 3 x 2.4kW Batteries - 7.2kW",
      "manufacturer": "Pylontech",
      "watts": 7200,
      "unit_cost": 1950,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 2,
      "Qty": 3
    },
    {
      "battery_id": 70,
      "description": "Pylontech - 4 x 2.4kW Batteries - 9.6kW",
      "manufacturer": "Pylontech",
      "watts": 9600,
      "unit_cost": 2400,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 2,
      "Qty": 4
    },
    {
      "battery_id": 4,
      "description": "Pylontech US3000 PLUS LV BATTERY 3.5kW",
      "manufacturer": "Pylontech",
      "watts": 3500,
      "unit_cost": 830,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 4,
      "Qty": 1
    },
    {
      "battery_id": 865,
      "description": "2 x Pylontech US3000 PLUS LV BATTERY 3.5kW",
      "manufacturer": "Pylontech",
      "watts": 7000,
      "unit_cost": 1660,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 4,
      "Qty": 2
    },
    {
      "battery_id": 870,
      "description": "3 x Pylontech US3000 PLUS LV BATTERY 3.5kW",
      "manufacturer": "Pylontech",
      "watts": 10500,
      "unit_cost": 2490,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 4,
      "Qty": 3
    },
    {
      "battery_id": 875,
      "description": "4 x Pylontech US3000 PLUS LV BATTERY 3.5kW",
      "manufacturer": "Pylontech",
      "watts": 14000,
      "unit_cost": 3320,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 4,
      "Qty": 4
    },
    {
      "battery_id": 20,
      "description": "Pylontech 3.5kW Off Grid High Voltage",
      "manufacturer": "Pylontech",
      "watts": 3500,
      "unit_cost": 2000,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 20,
      "Qty": 1
    },
    {
      "battery_id": 21,
      "description": "Pylontech 2 x 3.5kW Off Grid High Voltage - 7kW",
      "manufacturer": "Pylontech",
      "watts": 7000,
      "unit_cost": 4000,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 20,
      "Qty": 2
    },
    {
      "battery_id": 22,
      "description": "Pylontech 3 x 3.5kW Off Grid High Voltage - 10.5kW",
      "manufacturer": "Pylontech",
      "watts": 10500,
      "unit_cost": 6000,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 20,
      "Qty": 3
    },
    {
      "battery_id": 860,
      "description": "Pylontech 4 x 3.5kW Off Grid High Voltage - 14kW",
      "manufacturer": "Pylontech",
      "watts": 14000,
      "unit_cost": 8000,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 20,
      "Qty": 4
    },
    {
      "battery_id": 1030,
      "description": "Pylontech 5 x 3.5kW Off Grid High Voltage - 14kW",
      "manufacturer": "Pylontech",
      "watts": 17500,
      "unit_cost": 10000,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 20,
      "Qty": 5
    },
    {
      "battery_id": 1032,
      "description": "Pylontech 6 x 3.5kW Off Grid High Voltage - 14kW",
      "manufacturer": "Pylontech",
      "watts": 21000,
      "unit_cost": 12000,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 20,
      "Qty": 6
    },
    {
      "battery_id": 1034,
      "description": "Pylontech 7 x 3.5kW Off Grid High Voltage - 14kW",
      "manufacturer": "Pylontech",
      "watts": 24500,
      "unit_cost": 14000,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 20,
      "Qty": 7
    },
    {
      "battery_id": 1036,
      "description": "Pylontech 8 x 3.5kW Off Grid High Voltage - 14kW",
      "manufacturer": "Pylontech",
      "watts": 28000,
      "unit_cost": 16000,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 20,
      "Qty": 8
    },
    {
      "battery_id": 9,
      "description": "SOFAR 1 x 5.12kW GTX5000 Battery",
      "manufacturer": "SOFAR",
      "watts": 5120,
      "unit_cost": 1114,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 9,
      "Qty": 1
    },
    {
      "battery_id": 10,
      "description": "SOFAR 2 x 5.12kW GTX5000 Batteries- 10.24kW",
      "manufacturer": "SOFAR",
      "watts": 10240,
      "unit_cost": 2228,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 9,
      "Qty": 2
    },
    {
      "battery_id": 11,
      "description": "SOFAR 3 x 5.12kW GTX5000 Batteries - 15.36kW",
      "manufacturer": "SOFAR",
      "watts": 15360,
      "unit_cost": 3342,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 9,
      "Qty": 3
    },
    {
      "battery_id": 514,
      "description": "SOFAR 4 x 5.12kW GTX5000 Batteries - 20.48kW",
      "manufacturer": "SOFAR",
      "watts": 20480,
      "unit_cost": 4456,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 9,
      "Qty": 4
    },
    {
      "battery_id": 509,
      "description": "SOFAR 1 x 5.12kW High Voltage Battery",
      "manufacturer": "SOFAR",
      "watts": 5120,
      "unit_cost": 1150,
      "outofstock": true,
      "highvoltage": true,
      "Mapsto": 509,
      "Qty": 1
    },
    {
      "battery_id": 511,
      "description": "SOFAR 2 x 5.12kW High Voltage Battery",
      "manufacturer": "SOFAR",
      "watts": 10240,
      "unit_cost": 2300,
      "outofstock": true,
      "highvoltage": true,
      "Mapsto": 509,
      "Qty": 2
    },
    {
      "battery_id": 513,
      "description": "SOFAR 3 x 5.12kW High Voltage Battery",
      "manufacturer": "SOFAR",
      "watts": 15360,
      "unit_cost": 3450,
      "outofstock": true,
      "highvoltage": true,
      "Mapsto": 509,
      "Qty": 3
    },
    {
      "battery_id": 1014,
      "description": "SOFAR 4 x 5.12kW High Voltage Battery",
      "manufacturer": "SOFAR",
      "watts": 20480,
      "unit_cost": 4600,
      "outofstock": true,
      "highvoltage": true,
      "Mapsto": 509,
      "Qty": 4
    },
    {
      "battery_id": 840,
      "description": "Solaredge 1 x 10kW Energy Bank battery",
      "manufacturer": "Solaredge",
      "watts": 10000,
      "unit_cost": 4380,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 840,
      "Qty": 1
    },
    {
      "battery_id": 845,
      "description": "Solaredge 2 x 10kW Energy Bank battery - 20kW",
      "manufacturer": "Solaredge",
      "watts": 20000,
      "unit_cost": 8730,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 840,
      "Qty": 2
    },
    {
      "battery_id": 850,
      "description": "Solaredge 3 x 10kW Energy Bank battery - 30kW",
      "manufacturer": "Solaredge",
      "watts": 30000,
      "unit_cost": 13080,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 840,
      "Qty": 3
    },
    {
      "battery_id": 5,
      "description": "Solax Gen4 Hybrid 6.0kW Battery",
      "manufacturer": "Solax",
      "watts": 6000,
      "unit_cost": 1459,
      "outofstock": false,
      "highvoltage": false,
      "Mapsto": 5,
      "Qty": 1
    },
    {
      "battery_id": 6,
      "description": "Solax Gen4 Hybrid 7.5kW Battery",
      "manufacturer": "Solax",
      "watts": 7500,
      "unit_cost": 1542,
      "outofstock": true,
      "highvoltage": false,
      "Mapsto": 6,
      "Qty": 1
    },
    {
      "battery_id": 80,
      "description": "Solax High Voltage 5.8kW Battery",
      "manufacturer": "Solax",
      "watts": 5800,
      "unit_cost": 2100,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 80,
      "Qty": 1
    },
    {
      "battery_id": 820,
      "description": "2 x Solax High Voltage 5.8kW Battery",
      "manufacturer": "Solax",
      "watts": 11600,
      "unit_cost": 4200,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 80,
      "Qty": 2
    },
    {
      "battery_id": 830,
      "description": "3 x Solax High Voltage 5.8kW Battery",
      "manufacturer": "Solax",
      "watts": 17400,
      "unit_cost": 6300,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 80,
      "Qty": 3
    },
    {
      "battery_id": 1020,
      "description": "Solax 4 x 6.3kWh batteries AC Coupled 10.0kW Bundle",
      "manufacturer": "Solax",
      "watts": 25200,
      "unit_cost": 7771.11,
      "outofstock": false,
      "highvoltage": true,
      "Mapsto": 1020,
      "Qty": 4
    }
   ]
   export default batterymaps